import React, { useState, useEffect, useContext } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { ThemeContext } from "../../../Layout/Theme/ThemeContext";
import CustomerSelectionModal from "./CustomerSelectionModal";
import JobsEnginnerModal from "./JobsEnginnerModal";
import CustomerService from "../../../Customer/Controller/CustomerController";
import CustomerContactService from "../../../Customer/Controller/CustomerContactController";
import CustomerSiteService from "../../../Customer/Controller/CustomerSiteController";
import CallTypeService from "../../../Setup/controller/CallTypeController/CallTypeController";
import ProjectService from "../../../Setup/controller/ProjectController/ProjectController";
import JobService from "../../Controller/JobController";
import CurrencyService from "../../../Setup/controller/CurrencyController/CurrencyController";
import CurrencyTextField from "./CurrencyTextField";
//import CurrencyService from "../../../Setup/controller/CurrencyController/";
import { handleChange, handleSubmit } from "../../Controller/CreateJobController";
import { API_URL, API_KEY } from "../../../../config/CurrencyConfig"
import { formatDateWithFns } from '../../../Common/DateInputFormat';
import useDateFormat from '../../../Common/fetchDateFormat';
import Swal from 'sweetalert2';
import HelpSite from "../../../Common/HelpLink";
import { handleSubmit as handleContactNotesSubmit } from "../../../Customer/Controller/CreateCustomerHistoryController";
import { handleSubmit as handleJobSummarySubmit } from "../../Controller/CreateJobSummaryController";
import { handleSubmit as handleContactSubmit } from "../../../Customer/Controller/CreateCustomerContactController";
import TitleService from "../../../Setup/controller/TitleController/TitleController";
import Draggable from 'react-draggable';
import { JobSummaryValidation } from "../Validation/JobSummaryValidation";
import CreateCustomerSite from '../../../Customer/View/CustomerForms/CreateCustomerSite';
import SiteSelectionModal from "./SiteSelectionModal";
import ContactSelectionModal from "./ContactSelection";
function JobDetail({ JobID, onClose, onSuccess, ClientCompanyID }) {
    const navigate = useNavigate();
    const location = useLocation();
    const [errors, setErrors] = useState({});
    const [TitleList, setTitles] = useState([]);
    let JobCostID = localStorage.getItem('JobCostID');
    const getCurrentDateTime = () => {
        const now = new Date();
        const date = now.toISOString().split('T')[0]; // Format: YYYY-MM-DD
        const time = now.toTimeString().split(' ')[0]; // Format: HH:MM:SS
        return { date, time };
    };
    const { date, time } = getCurrentDateTime();

    const [CustomerList, setCustomer] = useState([]);
    const [CustomerContactList, setCustomerContact] = useState([]);
    const [CustomerSiteList, setCustomerSite] = useState([]);
    const [showCustomerModal, setShowCustomerModal] = useState(false);
    const { theme } = useContext(ThemeContext);
    const HelpLink = localStorage.getItem('HelpLink');
    const [showSuccessMessage, setShowSuccessMessage] = useState(false);
    const [showErrorMessage, setShowErrorMessage] = useState(false);

    const [defCurreny, setCurrency] = useState(null);
    //    const currencySymbol = defCurreny && defCurreny[0]?.Symbol || '$'; // Default to $ if no symbol
    // const [currencySymbol, setCurrencySymbol] = useState('');

    const [currencySymbol1, setCurrencySymbol1] = useState('');
    const [currencyValue1, setCurrencyValue1] = useState('');

    const [currencyCostSymbol1, setCostCurrencySymbol1] = useState('');
    const [currencyCostValue1, setCostCurrencyValue1] = useState('');
    const [BaseCurrency, setBaseCurrency] = useState('');
    const [jobMode, setJobMode] = useState('New');
    const [templateList, setTemplateList] = useState([]);
    const [selectedTemplate, setSelectedTemplate] = useState('');
    let accordTheme = "accordion-header-light";
    if (theme === "dark") {
        accordTheme = "accordion-header-dark";
    }
    const ProjectID = localStorage.getItem('ProjectID');
    const [currencyList, setCurrencies] = useState([]);
    const activeDateFormat = useDateFormat();
    const [CurrencyType, setCurrencyType] = useState(null);
    const [isClosed, SetIsClosed] = useState("0");

    const [currentCustomerSite, setCurrentCustomerSite] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isSiteModalOpen, setIsSiteModalOpen] = useState(false);
    const [isContactModalOpen, setIsContactModalOpen] = useState(false);
    useEffect(() => {
        const initializeData = async () => {
            SetIsClosed("0");
            fetchCurrency();
            fetchTitle();
            fetchCustomers();
            fetchCustomerCurrency();
            await fetchDefaultCurrency();
            if (ClientCompanyID > 0) {
                await fetchCustomerData(ClientCompanyID);
            }

        };
        initializeData();
    }, [JobID, ProjectID, JobCostID]);
    useEffect(() => {
        if (jobMode === 'FromTemplate') {
            fetchTemplates();
        }
    }, [jobMode]);
    const fetchTemplates = async () => {
        try {
            const redirectCallback = () => navigate('/');
            const list = await JobService.GetIssueTemplates(); // Example
            setTemplateList(list);
        } catch (error) {
            console.error('Error fetching templates:', error);
        }
    };

    const fetchCustomerCurrency = async () => {
        try {
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };
            const currencyData = await CurrencyService.fetchCustomerCurrency(redirectCallback);
            setCurrencyType(currencyData[0].CurrencyType);


        } catch (error) {
            console.error('Error fetching currencies:', error);
        }
    };
    const fetchTitle = async () => {
        try {
            const listOfTitles = await TitleService.GetAllTitle();
            setTitles(listOfTitles);
            if (listOfTitles.length > 0) {
                setFormData(formData => ({
                    ...formData,
                    Title: listOfTitles[0].Title, // Assuming IssuePriorityID is the field name
                }));
            }
        } catch (error) {
            console.error('Error fetching teams:', error);
        }
    };
    const fetchDefaultCurrency = async () => {
        try {
            const redirectCallback = () => navigate('/');
            const listOfCurreny = await CurrencyService.DefaultCurrency(redirectCallback);
            setCurrency(listOfCurreny);
            setCurrencySymbol1(listOfCurreny[0].Symbol);
            setCurrencyValue1("0.00");
            setCostCurrencySymbol1(listOfCurreny[0].Symbol);
            setCostCurrencyValue1("0.00");
            setBaseCurrency(listOfCurreny[0].Symbol);

        } catch (error) {
            console.error('Error fetching customers:', error);
        }
    };

    const fetchCustomers = async () => {
        try {
            const redirectCallback = () => navigate('/');
            const listOfCustomers = await CustomerService.GetAllCustomers(redirectCallback);
            setCustomer(listOfCustomers);
        } catch (error) {
            console.error('Error fetching customers:', error);
        }
    };


    const fetchCurrency = async () => {
        try {
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };
            const currencyData = await CurrencyService.GetAllCurrencies(redirectCallback);
            setCurrencies(currencyData);
        } catch (error) {
            console.error('Error fetching Teams:', error);
        }
    };




    const fetchCustomerContact = async (BranchID) => {
        try {

            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };
            setCustomerContact([]);
            const listOfCustomerContacts = await CustomerContactService.GetContactByBranch(redirectCallback, BranchID);
            setCustomerContact(listOfCustomerContacts);
            if (listOfCustomerContacts.length > 0) {
                setFormData((prevFormData) => ({
                    ...prevFormData,
                    FK_ClientContact_ID: listOfCustomerContacts[0].ClientContactID,
                    ContactName: `${listOfCustomerContacts[0].Title || ""} ${listOfCustomerContacts[0].FirstName || ""} ${listOfCustomerContacts[0].SurName || ""}`.trim(),
                }));
            }
        } catch (error) {
            console.error('Error fetching customer contacts:', error);
        }
    };

    const fetchCustomersSites = async (customerID) => {
        try {
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };

            const listOfCustomerSites = await CustomerSiteService.GetAllCustomersSites(redirectCallback, customerID);
            setCustomerSite(listOfCustomerSites);
            const headOfficeSite = listOfCustomerSites.find(site => site.HeadOffice === 1);
            if (headOfficeSite) {
                setFormData((prevFormData) => ({
                    ...prevFormData,
                    FK_ClientBranch_ID: headOfficeSite.ClientBranchID,
                }));
                await fetchCustomerContact(headOfficeSite.ClientBranchID);
            } else if (listOfCustomerSites.length > 0) {
                setFormData((prevFormData) => ({
                    ...prevFormData,
                    FK_ClientBranch_ID: headOfficeSite.ClientBranchID,
                }));
                await fetchCustomerContact(listOfCustomerSites[0].ClientBranchID);
            }
        } catch (error) {
            console.error('Error fetching customer sites:', error);
        }
    };



    const fetchJobDetailDetail = async () => {
        try {
            const redirectCallback = () => navigate('/');

            if (JobID > 0) {

                const jobDetail = await JobService.GetJobByID(redirectCallback, JobID);
                SetIsClosed(jobDetail[0].IsCompleted);
                localStorage.setItem("Closed", jobDetail[0].IsCompleted.toString());
                await fetchCustomerData(jobDetail[0].ClientCompanyID);


                const listOfCurreny = await CurrencyService.DefaultCurrency(redirectCallback);

                setBaseCurrency(listOfCurreny[0].Symbol);
                setCurrencyValue1(jobDetail[0].Estimate);
                setCostCurrencyValue1(jobDetail[0].mon_JobCost);
                const formattedDetail = {
                    ...jobDetail[0],
                    DateInvoiced: jobDetail[0].DateInvoiced
                        ? new Date(jobDetail[0].DateInvoiced).toISOString().split('T')[0]
                        : null,

                    TimeToCall: jobDetail[0].TimeToCall
                        ? new Date(jobDetail[0].TimeToCall).toISOString().split('T')[0]
                        : null,
                    CustomerID: jobDetail[0].ClientCompanyID,
                    AsbestosChecked: jobDetail[0].AsbestosChecked != null
                        ? jobDetail[0].AsbestosChecked.toString()
                        : null,

                    Estimate: jobDetail[0].Estimate,
                    mon_JobCost: jobDetail[0].mon_JobCost,

                };


                setFormData(formattedDetail);


            }
        } catch (error) {
            console.error('Error fetching agreement details:', error);
        }
    };


    const handleFieldChange = (event) => {
        handleChange(event, formData, setFormData);
    };

    const handleFormSubmit = async (event, submissionType) => {

        event.preventDefault();
        debugger;
        try {

            if (submissionType === "3") {
                if (formData.FK_ClientContact_ID === "-10") {
                    const contactData = {
                        ID: 0,
                        ClientCompanyID: formData.CustomerID,
                        ClientBranchID: formData.FK_ClientBranch_ID,
                        ContactTypeID: 0,
                        Title: formData.Title,
                        FirstName: formData.FirstName,
                        SurName: formData.SurName,
                        Email: "",
                        UserID: "0",
                        Phone: "",
                        Mobile: "",
                        Address1: "",
                        Address2: "",
                        Address3: "",
                        City: "",
                        County: "",
                        Postcode: "",
                        Country: "0",
                        Website: "",
                        AdditionalNotes: "",
                        TemplateID: "0",
                        IsEmailSend: "0"

                    }

                    const response = await handleContactSubmit(event, contactData, setFormData, setErrors);
                    formData.FK_ClientContact_ID = response.ClientContactID;
                }


                formData.ID = 0;
                formData.dt_Created = formData.TimeToCall;
                formData.snt_CommunicationType = "0";
                formData.vc_Description = formData.IssueTitle;
                formData.FK_Issue_ID = 0;
                formData.AppointmentDate = formData.TimeToCall;
                formData.DueDate = formData.TimeToCall;
                formData.vc_Subject = "";
                formData.vc_From = "";
                formData.vc_To = "";
                formData.vc_CC = "";
                formData.Completed = "0";
                formData.IsEmailSend = "0";
                formData.AssignUserID = localStorage.getItem('UserID')
                const response = await handleContactNotesSubmit(event, formData, setFormData, setErrors);
                debugger;
                if (response.data.message === "User added successfully") {
                    onSuccess();
                }
            }
            else {
                if (jobMode != "FromTemplate") {
                    const redirectCallback = () => {
                        navigate('/'); // Redirect to the login page
                    };
                    formData.ID = 0;
                    formData.ProjectID = ProjectID;
                    let EstimateBaseToCurrencyRate = "1.00";
                    let CostBaseToCurrencyRate = "1.00";
                    let finalCurrencySymbol = currencySymbol1;
                    if (!currencySymbol1 || currencySymbol1 === "undefined") {
                        finalCurrencySymbol = BaseCurrency;
                    }
                    formData.Estimate = currencyValue1;
                    const IsCurrencyExist = await CurrencyService.CurrenyBySymbol(redirectCallback, finalCurrencySymbol);
                    const BaseCurrenctCode = await CurrencyService.CurrenyBySymbol(redirectCallback, BaseCurrency);
                    if (IsCurrencyExist.length === 0) {
                        alert("The currency symbol in Estimate does not exist");
                        return false;
                    }
                    //  BaseCurrency

                    if (finalCurrencySymbol != BaseCurrency) {
                        if (CurrencyType == "Auto") {
                            const currencyCodes = currencyList.map(currency => currency.vc_CurrencyCode).join(',');
                            const apiUrl = `${API_URL}latest?apikey=${API_KEY}&currencies=${currencyCodes}&base_currency=${IsCurrencyExist[0].vc_CurrencyCode}`;
                            const response = await fetch(apiUrl);
                            const responseData = await response.json();
                            if (responseData.data) {
                                const BaseCurrencyCode = BaseCurrenctCode[0].vc_CurrencyCode;
                                const exchangeRates = responseData.data;
                                if (exchangeRates[BaseCurrencyCode]) {
                                    const exchangeRate = exchangeRates[BaseCurrencyCode]; // This is the rate for your BaseCurrencyCode
                                    formData.Estimate = (formData.Estimate * exchangeRate);
                                    EstimateBaseToCurrencyRate = exchangeRate;

                                }
                            }
                        }
                        else {

                            formData.Estimate = (formData.Estimate * (1 / (IsCurrencyExist[0].dec_CurrencyToBaseRate)));
                            EstimateBaseToCurrencyRate = IsCurrencyExist[0].dec_CurrencyToBaseRate;

                        }
                    }

                    let finalCurrencyCostSymbol = currencyCostSymbol1;
                    if (!currencyCostSymbol1 || currencyCostSymbol1 === "undefined") {
                        finalCurrencyCostSymbol = BaseCurrency;
                    }
                    formData.mon_JobCost = currencyCostValue1;
                    const IsCurrencyCostExist = await CurrencyService.CurrenyBySymbol(redirectCallback, finalCurrencyCostSymbol);

                    if (IsCurrencyCostExist.length === 0) {
                        alert("The currency symbol in Cost does not exist");
                        return false;
                    }
                    if (finalCurrencyCostSymbol != BaseCurrency) {
                        if (CurrencyType == "Auto") {
                            const currencyCodes = currencyList.map(currency => currency.vc_CurrencyCode).join(',');
                            const apiUrl = `${API_URL}latest?apikey=${API_KEY}&currencies=${currencyCodes}&base_currency=${IsCurrencyCostExist[0].vc_CurrencyCode}`;
                            const response = await fetch(apiUrl);
                            const responseData = await response.json();
                            if (responseData.data) {
                                const BaseCurrencyCode = BaseCurrenctCode[0].vc_CurrencyCode;
                                const exchangeRates = responseData.data;
                                if (exchangeRates[BaseCurrencyCode]) {
                                    const exchangeRate = exchangeRates[BaseCurrencyCode]; // This is the rate for your BaseCurrencyCode
                                    formData.mon_JobCost = (formData.mon_JobCost * exchangeRate);
                                    CostBaseToCurrencyRate = exchangeRate;

                                }
                            }
                        }
                        else {
                            formData.mon_JobCost = (formData.mon_JobCost * (1 / (IsCurrencyCostExist[0].dec_CurrencyToBaseRate)));
                            CostBaseToCurrencyRate = IsCurrencyCostExist[0].dec_CurrencyToBaseRate;
                        }
                    }


                    formData.Estimate = parseFloat(formData.Estimate).toFixed(2);
                    formData.mon_JobCost = parseFloat(formData.mon_JobCost).toFixed(2);
                    formData.BaseCurrency = BaseCurrency;
                    formData.EstimatedCurrency = finalCurrencySymbol;
                    formData.CostCurrency = finalCurrencyCostSymbol;
                    formData.EstimateBaseToCurrencyRate = EstimateBaseToCurrencyRate;
                    formData.CostBaseToCurrencyRate = CostBaseToCurrencyRate;
                    formData.submissionType = submissionType;
                    const formErrors = JobSummaryValidation(formData, submissionType);
                    setErrors(formErrors);
                    if (Object.keys(formErrors).length === 0) {
                        const response = await handleJobSummarySubmit(event, formData, setFormData, setErrors);
                        debugger
                        if (response.message === "Data saved successfully") {
                            onSuccess(submissionType, response.JobID);
                        }
                    }
                }
                else {
                    if (formData.TemplateID > 0) {
                        const response = await JobService.CreateJobFromTemplate(formData.TemplateID, formData.FK_ClientContact_ID, formData.TimeToCall, formData.CallTime);
                        debugger;
                        if (response.message === "Data saved successfully") {
                            onSuccess(submissionType, response.JobID);
                        }
                    }
                    else {
                        Swal.fire({
                            title: '',
                            text: `Please select template`,
                            icon: 'warning'
                        });
                    }
                }

            }


        } catch (error) {
            console.error('Error submitting form:', error);
            setErrors({ submit: 'An error occurred while submitting the form. Please try again.' });
        }
    };

    const handleCustomerSelect = async (customer) => {


        const newCurrencySymbol = customer.vc_CurrencySymbol;
        setFormData({
            ...formData,
            CustomerID: customer.ClientCompanyID,
            CustomerName: customer.CompanyName,
            AccountRef: customer.AccountRef,
            FK_ClientBranch_ID: customer.ClientBranchID,
            FK_ClientContact_ID: customer.ClientContactID,
            FK_Currency_ID: customer.vc_CurrencySymbol,
            BranchName: customer.BranchName,
        });
        fetchCustomerContact(customer.ClientBranchID);
        fetchCustomersSites(customer.ClientCompanyID);
        setShowCustomerModal(false);
    };
    const fetchCustomerData = async (customerID) => {
        try {
            const redirectCallback = () => navigate('/');
            const customerData = await CustomerService.GetCustomerByID(redirectCallback, customerID);

            setFormData((prevFormData) => ({
                ...prevFormData,
                AccountRef: customerData[0].AccountRef,
                FK_Currency_ID: customerData[0].vc_CurrencySymbol,
                CustomerName: customerData[0].CompanyName,
            }));
            await fetchCustomerContact(customerID);
            await fetchCustomersSites(customerID);
            if (ClientCompanyID > 0) {
                await handleCustomerSelect(customerData[0]);
            }

        } catch (error) {
            console.error('Error fetching customer data:', error);
        }
    };

    const [formData, setFormData] = useState({
        CustomerID: 0,
        IssueID: 0,
        CustomerName: '',
        FK_ClientBranch_ID: 0,
        FK_ClientContact_ID: 0,
        IssueTitle: "",
        Estimate: "0.00",
        mon_JobCost: "0.00",
        TimeToCall: date,
        CallTime: time,
        Solution: "",
        Title: 'Mr',
        FirstName: '',
        SurName: '',
        TemplateID: '0',
        EndDate: date,
        EndTime: time,
        ContactName: "",
        BranchName: ""

    });
    const resetForm = () => {

        setFormData({
            CustomerID: 0,
            IssueID: 0,
            CustomerName: '',
            FK_ClientBranch_ID: 0,
            FK_ClientContact_ID: 0,
            IssueTitle: "",
            Estimate: "0.00",
            mon_JobCost: "0.00",
            TimeToCall: date,
            CallTime: time,
            Solution: "",
            EndDate: date,
            EndTime: time,
            ContactName: "",
            BranchName: ""
        });
    };
    const handleCurrencyChange = ({ symbol, value }) => {
        setCurrencySymbol1(symbol);
        setCurrencyValue1(value);
    };
    const handleCostCurrencyChange = ({ symbol, value }) => {
        setCostCurrencySymbol1(symbol);
        setCostCurrencyValue1(value);
    };
    const handleStart = (e, ui) => {
        e.stopPropagation();
    }
    const redirectCallback = () => {
        navigate('/'); // Redirect to the login page
    };
    const handleCreateCustomerSiteClick = (e) => {
        e.preventDefault();
        if (formData.CustomerID > 0) {
            if (localStorage.getItem('CustomerSiteContact') === null) {
                localStorage.setItem('CustomerSiteContact', "0");
            }
            setCurrentCustomerSite(null);
            setIsModalOpen(true);
        }
        else {
            Swal.fire({
                title: '',
                text: `Please select customer first to add Site`,
                icon: 'warning'
            });
        }
    };
    const handleSuccess = async (CustomerSiteID) => {
        debugger;
        await fetchCustomersSites(formData.CustomerID); // Refresh the list after submission
        await fetchCustomerContact(CustomerSiteID);
        const CustomerSite = await CustomerSiteService.GetCustomerSiteByID(redirectCallback, CustomerSiteID);

        if (CustomerSite && CustomerSite.length > 0) {
            setFormData(prevFormData => ({
                ...prevFormData,
                FK_ClientBranch_ID: CustomerSiteID,
                Address1: CustomerSite[0].BranchAddress,
            }));
        } else {
            console.warn("No customer site found for ID", CustomerSiteID);
        }
        handleCloseSiteModal();   // Close the modal

    };
    const handleCloseSiteModal = () => {
        setIsModalOpen(false);
    };
    const handleBranchChange = async (event) => {
        const { value } = event.target;
        const branchID = event.target.value;
        setFormData({
            ...formData,
            FK_ClientBranch_ID: value,
            FK_ClientContact_ID: 0
        });
        await fetchCustomerContact(value);

    };
    const handleSelectSite = async (site) => {


        const CustomerSite = await CustomerSiteService.GetCustomerSiteByID(redirectCallback, site.ClientBranchID);

        if (CustomerSite && CustomerSite.length > 0) {
            setFormData(prevFormData => ({
                ...prevFormData,
                FK_ClientBranch_ID: site.ClientBranchID,
                Address1: CustomerSite[0].BranchAddress,

                BranchName: site.BranchName,
            }));

            fetchCustomerContact(site.ClientBranchID);
        } else {
            console.warn("No customer site found for ID", site.ClientBranchID);
        }


        handleCloseSiteSelectionModal();   // Close the modal
    };
    const handleSelectContact = async (contact) => {

        setFormData(prevFormData => ({
            ...prevFormData,
            FK_ClientContact_ID: contact.ClientContactID,
            ContactName: contact.ContactName,
        }));

        handleCloseContactSelectionModal();   // Close the modal
    };


    const handleCloseSiteSelectionModal = () => {
        setIsSiteModalOpen(false);
    };
    const handleCloseContactSelectionModal = () => {
        setIsContactModalOpen(false);
    };
    return (
        <div>
            {showSuccessMessage && (
                <div class="alert alert-success bg-success text-light border-0 alert-dismissible fade show" role="alert">
                    Data saved successfully.
                </div>
            )}
            {showErrorMessage && (
                <div class="alert alert-danger bg-danger text-light border-0 alert-dismissible fade show" role="alert">
                    Validation Error.

                </div>
            )}
            <div className="row mb-3" style={{ "marginLeft": "0px" }}>
                <div class='col-sm-12' style={{ "textAlign": "right" }}>
                    <HelpSite FormName="Job Details" Module="11" />
                </div>
            </div>
            <form>
                <div className="modal fade jobPartModal show d-block" id="jobPartModal" tabIndex="-1" aria-labelledby="jobPartModalLabel" aria-hidden="true" data-backdrop="static">

                    <div className="modal-dialog modal-lg">
                        <Draggable handle=".modal-header" onStart={handleStart}
                            cancel="input, textarea, select, button, ul,li,table,a,ReactQuill,p"
                            bounds={{ top: 0, bottom: window.innerHeight - 400 }}>
                            <div className="modal-content">
                                <div className={`modal-header ${accordTheme}`}>
                                    <h5 className="modal-title" id="largeModalLabel">Add Job</h5>
                                    <button type="button" className="close" aria-label="Close" onClick={onClose}>
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body" style={{ "maxHeight": "500px", "overflow": "auto" }}>



                                    <div className="row mb-3" style={{ "marginLeft": "5px", "marginRight": "5px", marginTop: "10px" }}>
                                        <label htmlFor="TimeToCall" className="col-sm-2 col-form-label">Job Start Date / Time :</label>
                                        <div className="col-sm-2">
                                            <input type="date" className="form-control" name="TimeToCall" value={formData.TimeToCall} onChange={handleFieldChange} disabled={isClosed === '1' || isClosed === 1} />
                                            {errors.TimeToCall && <div style={{ "color": "red", "fontsize": "0.8vw" }}>{errors.TimeToCall}</div>}
                                        </div>
                                        <div className="col-sm-2">
                                            <input type="time" className="form-control" name="CallTime" value={formData.CallTime} onChange={handleFieldChange} disabled={isClosed === '1' || isClosed === 1} />
                                            {errors.CallTime && <div style={{ "color": "red", "fontsize": "0.8vw" }}>{errors.CallTime}</div>}
                                        </div>

                                        <label className="col-sm-2 col-form-label" htmlFor="TimeToCall" style={{ float: "right" }}>End Date :&nbsp;&nbsp;</label>
                                        <div className="col-sm-2">
                                            <input type="date" className="form-control" name="EndDate" value={formData.EndDate} onChange={handleFieldChange} disabled={isClosed === '1' || isClosed === 1} />
                                            {errors.EndDate && <div style={{ "color": "red", "fontsize": "0.8vw" }}>{errors.EndDate}</div>}
                                        </div>
                                        <div className="col-sm-2">
                                            <input type="time" className="form-control" name="EndTime" value={formData.EndTime} onChange={handleFieldChange} disabled={isClosed === '1' || isClosed === 1} />
                                            {errors.EndTime && <div style={{ "color": "red", "fontsize": "0.8vw" }}>{errors.EndTime}</div>}
                                        </div>
                                    </div>
                                    <div className="row mb-3" style={{ "marginLeft": "5px", "marginRight": "5px" }}>
                                        <label htmlFor="CustomerID" className="col-sm-2 col-form-label"> Customer:<span style={{ "color": "red" }}>*</span></label>
                                        <div className="col-sm-4">
                                            <input type='hidden' name="IssueID" id="IssueID" value={formData.IssueID} />
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="CustomerID"
                                                name="CustomerID"
                                                value={formData.CustomerName}
                                                onClick={() => setShowCustomerModal(true)}
                                                readOnly
                                                disabled={isClosed === '1' || isClosed === 1}

                                            />
                                            {errors.CustomerID && <div style={{ "color": "red", "fontSize": "0.8vw" }}>{errors.CustomerID}</div>}
                                        </div>

                                        <label htmlFor="vc_SerialNumber" className="col-sm-2 col-form-label"> Site :<span style={{ "color": "red" }}>*</span></label>
                                        <div className="col-sm-3">
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="FK_ClientBranch_ID"
                                                name="FK_ClientBranch_ID"
                                                value={formData.BranchName}
                                                onClick={() => setIsSiteModalOpen(true)}
                                                readOnly
                                                disabled={isClosed === '1' || isClosed === 1}

                                            />
                                            {errors.FK_ClientBranch_ID && <div style={{ "color": "red", "fontSize": "0.8vw" }}>{errors.FK_ClientBranch_ID}</div>}
                                        </div>
                                        <div className="col-sm-1" style={{ paddingLeft: "0px" }}>
                                            <button type="button" className='btn btn-primary btn-sm' style={{ background: "#2E7D32", padding: "2px 3px", float: "right" }} onClick={handleCreateCustomerSiteClick} disabled={isClosed === '1' || isClosed === 1 || localStorage.getItem('LicenseExpired') == "1"}>
                                                <i className="icofont-plus" aria-hidden="true"></i>
                                            </button>
                                        </div>
                                    </div>
                                    <div className="row mb-3" style={{ "marginLeft": "5px", "marginRight": "5px" }}>
                                        <label htmlFor="FK_ClientContact_ID" className="col-sm-2 col-form-label"> Contact :<span style={{ "color": "red" }}>*</span></label>
                                        <div className="col-sm-4">
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="FK_ClientContact_ID"
                                                name="FK_ClientContact_ID"
                                                value={formData.ContactName}
                                                onClick={() => setIsContactModalOpen(true)}
                                                readOnly
                                                disabled={isClosed === '1' || isClosed === 1}

                                            />

                                            {errors.FK_ClientContact_ID && <div style={{ "color": "red", "fontSize": "0.8vw" }}>{errors.FK_ClientContact_ID}</div>}
                                        </div>
                                        <label htmlFor="AccountRef" className="col-sm-2 col-form-label">Account Ref</label>
                                        <div className="col-sm-4">
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="AccountRef"
                                                name="AccountRef"
                                                value={formData.AccountRef}
                                                onChange={(e) => setFormData({ ...formData, AccountRef: e.target.value })}
                                                readOnly
                                            />
                                        </div>
                                    </div>

                                    {formData.FK_ClientContact_ID === '-10' && (
                                        <>
                                            <div className="row mb-3" style={{ "marginLeft": "5px", "marginRight": "5px" }}>
                                                <label htmlFor="Title" className="col-sm-2 col-form-label">Title:</label>
                                                <div className="col-sm-4">
                                                    <select name="Title" className='form-control' value={formData.Title} onChange={handleFieldChange}>
                                                        <option value="0">Select Title</option>
                                                        {TitleList.map((title) => (
                                                            <option key={title.Title} value={title.Title}>
                                                                {title.Title}
                                                            </option>
                                                        ))}
                                                    </select>
                                                    {errors.Title && <div style={{ color: 'red' }}>{errors.Title}</div>}
                                                </div>
                                            </div>
                                            <div className="row mb-3" style={{ "marginLeft": "5px", "marginRight": "5px" }}>
                                                <label htmlFor="FirstName" className="col-sm-2 col-form-label">Forename:<span style={{ "color": "red" }}>*</span></label>
                                                <div className="col-sm-4">
                                                    <input type="text" className="form-control" name="FirstName" value={formData.FirstName} onChange={handleFieldChange} />
                                                    {errors.FirstName && <div style={{ color: 'red' }}>{errors.FirstName}</div>}
                                                </div>


                                                <label htmlFor="SurName" className="col-sm-2 col-form-label">Surname:<span style={{ "color": "red" }}>*</span></label>
                                                <div className="col-sm-4">
                                                    <input type="text" className="form-control" name="SurName" value={formData.SurName} onChange={handleFieldChange} />
                                                    {errors.SurName && <div style={{ color: 'red' }}>{errors.SurName}</div>}
                                                </div>

                                            </div>
                                        </>
                                    )}
                                    <div className="row mb-3" style={{ marginLeft: "5px", marginRight: "5px", "marginTop": "10px" }}>
                                        <label htmlFor="jobMode" className="col-sm-2 col-form-label">Select:</label>
                                        <div className="col-sm-4">
                                            <select
                                                id="jobMode"
                                                className="form-control"
                                                value={jobMode}
                                                onChange={(e) => setJobMode(e.target.value)}
                                            >
                                                <option value="New">New</option>
                                                <option value="FromTemplate">From Template</option>
                                            </select>
                                        </div>
                                    </div>
                                    {jobMode === 'FromTemplate' && (
                                        <div className="row mb-3" style={{ marginLeft: "5px", marginRight: "5px" }}>
                                            <label htmlFor="template" className="col-sm-2 col-form-label">Select Template:</label>
                                            <div className="col-sm-6">
                                                <select name="TemplateID" className='form-control'
                                                    value={formData.TemplateID} onChange={handleFieldChange} >

                                                    <option value="">Select Template</option>
                                                    {templateList.map((template) => (
                                                        <option key={template.IssueID} value={template.IssueID}>
                                                            {template.TemplateName}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>
                                    )}
                                    {jobMode != 'FromTemplate' && (
                                        <>
                                            <div className="row mb-3" style={{ "marginLeft": "5px", "marginRight": "5px" }}>
                                                <label htmlFor="IssueTitle" className="col-sm-2 col-form-label">Job Details:<span style={{ "color": "red" }}>*</span></label>
                                                <div className="col-sm-10">
                                                    <textarea type="text" rows={2} className="form-control" name="IssueTitle" value={formData.IssueTitle} disabled={isClosed === '1' || isClosed === 1} onChange={handleFieldChange} />
                                                    {errors.IssueTitle && <div style={{ "color": "red", "fontSize": "0.8vw" }}>{errors.IssueTitle}</div>}
                                                </div>

                                            </div>

                                            <div className="row mb-3" style={{ "marginLeft": "5px", "marginRight": "5px" }}>
                                                <label htmlFor="Estimate" className="col-sm-2 col-form-label">Est. Price:</label>
                                                <div className="col-sm-4">
                                                    <CurrencyTextField initialCurrencySymbol={currencySymbol1} initialCurrencyValue={currencyValue1} onCurrencyChange={handleCurrencyChange} currencyList={currencyList} disabled={isClosed === '1' || isClosed === 1} />

                                                </div>
                                                <label htmlFor="mon_JobCost" className="col-sm-2 col-form-label">Cost:</label>
                                                <div className="col-sm-4">
                                                    <CurrencyTextField initialCurrencySymbol={currencyCostSymbol1} initialCurrencyValue={currencyCostValue1} onCurrencyChange={handleCostCurrencyChange} currencyList={currencyList} disabled={isClosed === '1' || isClosed === 1} />

                                                </div>
                                            </div>

                                            <div className="row mb-3" style={{ "marginLeft": "5px", "marginRight": "5px" }}>
                                                <label htmlFor="IssueTitle" className="col-sm-2 col-form-label">Solution:</label>
                                                <div className="col-sm-10">
                                                    <textarea type="text" rows={2} className="form-control" name="Solution" value={formData.Solution} disabled={isClosed === '1' || isClosed === 1} onChange={handleFieldChange} />
                                                    {errors.Solution && <div style={{ "color": "red", "fontSize": "0.8vw" }}>{errors.Solution}</div>}
                                                </div>
                                            </div>
                                        </>
                                    )}
                                    <div className="row" style={{ "marginTop": "10px", "marginLeft": "5px", "marginRight": "5px", "float": "right" }}>
                                        <button type="button" className="btn btn-primary" style={{ "marginLeft": "5px" }} disabled={isClosed === '1' || isClosed === 1} onClick={(event) => handleFormSubmit(event, "1")}>
                                            <i className="icofont-save" aria-hidden="true">
                                                {JobID > 0 ? ' Update' : ' Save'}
                                            </i>
                                        </button>
                                        {jobMode != 'FromTemplate' && (
                                            <>
                                                <button type="button" className="btn btn-success" style={{ "marginLeft": "5px" }} disabled={isClosed === '1' || isClosed === 1} onClick={(event) => handleFormSubmit(event, "2")}>
                                                    <i className="icofont-save" aria-hidden="true">
                                                        Complete
                                                    </i>
                                                </button>
                                                <button type="button" className="btn btn-warning" style={{ "marginLeft": "5px" }} disabled={isClosed === '1' || isClosed === 1} onClick={(event) => handleFormSubmit(event, "3")}>
                                                    <i className="icofont-save" aria-hidden="true">
                                                        Add to History
                                                    </i>
                                                </button>
                                            </>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </Draggable>
                    </div>
                </div>
            </form >
            <CustomerSelectionModal
                show={showCustomerModal}
                onClose={() => setShowCustomerModal(false)}
                customers={CustomerList}
                onSelectCustomer={handleCustomerSelect}
                refreshCustomers={CustomerList}
            />
            {isModalOpen && (
                <CreateCustomerSite
                    site={currentCustomerSite}
                    onClose={handleCloseSiteModal}
                    onSuccess={handleSuccess}
                    CustomerID={formData.CustomerID}
                />
            )}
            {isSiteModalOpen && (
                <SiteSelectionModal
                    show={isSiteModalOpen}
                    onClose={handleCloseSiteSelectionModal}
                    onSelectSite={handleSelectSite}
                    ClientCompanyID={formData.CustomerID}
                />
            )}
            {isContactModalOpen && (
                <ContactSelectionModal
                    show={isContactModalOpen}
                    onClose={handleCloseContactSelectionModal}
                    onSelectContact={handleSelectContact}
                    ClientBranchID={formData.FK_ClientBranch_ID}
                />
            )}

        </div >
    );
}

export default JobDetail;
